const site = {
  slug: 'novodom-storefront',
  brand: 'Novodom',
  domain: 'mynovodom.com',
  locale: 'en-US',
  currency: 'USD',
  apiBase: import.meta.env.VITE_API_BASE || '/api',
  preview: true,
  supportEmail: 'hello@mynovodom.com',
  partnerEmail: 'partners@mynovodom.com',
  theme: {
    ink: '#241d19',
    paper: '#f7f1e8',
    surface: '#fffaf3',
    accent: '#a4472e',
    accentSoft: '#efd1bf',
    line: '#d8c9bb',
    radius: '18px',
    displayFont: 'Cormorant Garamond, Georgia, Times New Roman, serif',
    bodyFont: 'Inter, ui-sans-serif, system-ui, sans-serif',
  },
  announcement: 'Private-label preview · U.S. launch details and checkout are not yet live',
  navigation: [
    { label: 'Private label', href: '#private-label' },
    { label: 'Lash library', href: '#products' },
    { label: 'How it works', href: '#process' },
    { label: 'Wholesale', href: '#wholesale' },
  ],
  hero: {
    eyebrow: 'Private-label lashes for creators & beauty pros',
    title: 'Your audience. Your lash line. In 21–45 days.',
    body: 'Novodom turns a beauty point of view into a launch-ready lash collection—from style edits and samples to packaging, production, and replenishment.',
    primaryLabel: 'Build your lash brief',
    primaryHref: '#private-label',
  },
  story: {
    eyebrow: 'The supply-chain partner behind the label',
    title: 'Start with three audience-matched styles—not a warehouse of guesses.',
    body: 'We help creators, lash techs, makeup artists, and emerging beauty founders test a focused edit before committing to a larger run. Product claims, labeling, fulfillment, and commercial terms remain subject to final written approval.',
  },
  trust: ['Focused sample edit', 'Low-volume launch path', 'Retail + wholesale ready', 'Dedicated Novodom data'],
  fallbackProducts: [
    {
      id: 'first-edit-sample-set',
      name: 'First Edit Sample Set',
      description: 'A focused style review for founders who need to compare band, fiber, curl, and eye-shape fit before packaging decisions.',
      style: '4 sample lash directions',
      price: '24.00',
      compareAt: null,
      badge: 'Founder sample',
      type: 'Sample set',
      visual: 'sample',
      media: [],
      variants: [{ id: 'sample-edit', sku: 'NOV-SAMPLE-EDIT', label: 'Sample edit', price: '24.00', stock: 30 }],
    },
    {
      id: 'soft-focus-three-pair',
      name: 'Soft Focus 3-Pair',
      description: 'A natural-to-soft-glam progression designed for daily content, beginner wear, and repeat purchase.',
      style: 'Natural · soft glam · lifted',
      price: '32.00',
      compareAt: null,
      badge: 'Retail preview',
      type: 'Lash collection',
      visual: 'soft',
      media: [],
      variants: [{ id: 'soft-focus', sku: 'NOV-SOFT-3', label: '3-pair set', price: '32.00', stock: 25 }],
    },
    {
      id: 'creator-trial-box',
      name: 'Creator Trial Box',
      description: 'A content-ready assortment for testing reactions across three audience profiles before a custom production run.',
      style: '12 pairs · 3 audience edits',
      price: '68.00',
      compareAt: null,
      badge: 'Creator program',
      type: 'Testing kit',
      visual: 'creator',
      media: [],
      variants: [{ id: 'creator-trial', sku: 'NOV-CREATOR-12', label: '12-pair trial', price: '68.00', stock: 12 }],
    },
    {
      id: 'lash-tech-retail-kit',
      name: 'Lash Tech Retail Kit',
      description: 'A compact shelf-ready starter assortment for beauty professionals adding take-home strip lashes to their service business.',
      style: '18 pairs · display-ready mix',
      price: '96.00',
      compareAt: null,
      badge: 'Wholesale preview',
      type: 'Professional kit',
      visual: 'pro',
      media: [],
      variants: [{ id: 'lash-tech-kit', sku: 'NOV-PRO-18', label: '18-pair starter', price: '96.00', stock: 10 }],
    },
  ],
};

export default site;
